export const DIR = 'rtl';
export const CODE = 'ar';
export const ALT_LANG = 'English';
export const ALT_CODE = 'en';
export const TITLE = 'فصول';
export const COPYRIGHT = 'فصول ٢٠١٩ ©';
export const ABOUT = 'من نحن';
export const CONTACT = 'اتصل بنا';
export const SUPPORT = 'الدعم';
export const TERMS = 'الشروط';
export const FEATURES = 'المميزات';
export const TAG_LINE = 'أفضل وسيلة للتواصل ما بين الطالب والمعلم';
export const ANDROID = 'أندرويد';
export const IPHONE = 'أيفون';
export const WEB_APP = 'تطبيق ويب';
export const KEYWORDS =
    'تطبيق, دردشة, محادثات, تعليم, واتساب تعليمي, محادثات تعليمية, دردشة تعليمية, طلاب, معلمين, مدرسين, اختبارات, واجبات, تكاليف, كويزات, اختبارات إلكترونية, مهام, تصويت, منهج تعليمي';
export const DESCRIPTION =
    'فصول هو تطبيق محادثات جماعية مصمم خصيصا للطلاب والمعلمين. يمكنك فصول من المحافظة على خصوصيتك وعدم مشاركة رقم هاتفك او بريدك الالكتروني. بالاضافة الى تنسيق المهام والتكاليف والإختبارات وكذلك توفير مكتبة مستندات إلكترونية لكل مجموعة.';
export const ABOUT_TEXT = `قريبا...`;



// WEBPACK FOOTER //
// ./src/lang/ar.js